import { render, staticRenderFns } from "./WorkshopFormData.vue?vue&type=template&id=74f0b3ed"
import script from "./WorkshopFormData.vue?vue&type=script&lang=ts"
export * from "./WorkshopFormData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports